import React from 'react';
import ReactDOM from 'react-dom/client';
import SealSearch from './SealSearch';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-seal-search',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<SealSearch />
		</React.StrictMode>
	);
}
